export default "__VITE_ASSET__Dg2akzvY__"